/**
 * Represents a mapping between a data key, its corresponding display name,
 * and the target Excel worksheet column where the value should be written.
 */
export interface ColumnMapping {
    Key: string;
    DisplayName: string;
    Column: string;
  }